import   React                            ,
       { useState                         ,
         useEffect                        ,
         useRef                           }  from "react";

import   classNames                          from "classnames";

import   styles                              from "./MonthlySummary.module.scss";

import   WidgetFrame                         from '../../../widget/navigation/WidgetFrame';
import   AnimatedWaitingIcon                 from '../../../widget/animations/animatedWaitingIcon';

import { getTurnoverAndPaymentCount       }  from '../../../../backendServices/paymentManagment/api';
		 

const MonthlySummary: React.FC = () => {

  const now = new Date();

  const currentMonthStart  = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
  const currentMonthEnd    = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);

  const [ showWaitingIcon          , setShowWaitingIcon          ] = useState(false);

  const [ monthlyRevenue           , setMonthlyRevenue           ] = useState (0)
  const [ monthlyOrderCount        , setMonthlyOrderCount        ] = useState (0)
  const [ monthlyAverageOrderValue , setMonthlyAverageOrderValue ] = useState (0)

  const [ monthlySummaryWidth      , setMonthlySummaryWidth      ] = useState(232);
  const [ monthlySummaryFontSize1  , setMonthlySummaryFontSize1  ] = useState(16);
  const [ monthlySummaryFontSize2  , setMonthlySummaryFontSize2  ] = useState(18);
  const [ monthlySummaryReady      , setMonthlySummaryReady      ] = useState(false)

  const intervalRef       = useRef<NodeJS.Timeout | null>(null);
  const monthlySummaryRef = useRef<HTMLDivElement | null>(null);

  const fetchData = async () => {
	  
    try 
     {
      setShowWaitingIcon(true);

      const getTurnoverAndPaymentCountResponse = await getTurnoverAndPaymentCount(currentMonthStart, currentMonthEnd)

      if (getTurnoverAndPaymentCountResponse.code === 1) 
	        {
             setMonthlyOrderCount(getTurnoverAndPaymentCountResponse.payload.paymentCount);
             setMonthlyRevenue(getTurnoverAndPaymentCountResponse.payload.turnover);

             if (getTurnoverAndPaymentCountResponse.payload.paymentCount !== 0) 
	      	       {
                    setMonthlyAverageOrderValue(getTurnoverAndPaymentCountResponse.payload.turnover / getTurnoverAndPaymentCountResponse.payload.paymentCount);
                   } 
		      else {
                    setMonthlyAverageOrderValue(0);
                   }
            } 
	   else {
             setMonthlyOrderCount(0);
             setMonthlyRevenue(0);
             setMonthlyAverageOrderValue(0);
            }
     } 
	catch (error) 
	 {
      console.error("Erreur lors de la récupération des sessions :", error);
     }

   setShowWaitingIcon(false);
  };

  useEffect(() => {

    fetchData(); 

    intervalRef.current = setInterval(fetchData, 60000); // 60000 milliseconds = 1 minute

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current); // Nettoyage de l'intervalle lors du démontage du composant
      }
    };
  }, []);

  const updateWidth = () => {
      if (monthlySummaryRef.current) {
        const newWidth = monthlySummaryRef.current.clientWidth;
        setMonthlySummaryWidth(newWidth);
      }
  };

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      updateWidth();
    });

    if (monthlySummaryRef.current) {
      resizeObserver.observe(monthlySummaryRef.current);
      updateWidth();
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    if (monthlySummaryRef.current) {
      setMonthlySummaryWidth(monthlySummaryRef.current.clientWidth);
      setMonthlySummaryReady(true);
    }
  }, [monthlySummaryRef.current]);

  useEffect(() => {
    if (monthlySummaryWidth > 0) {
      setMonthlySummaryFontSize1(monthlySummaryWidth * 0.065);
      setMonthlySummaryFontSize2(monthlySummaryWidth * 0.070);
    }
  }, [monthlySummaryWidth]);

  const renderMonthlySummary = () : JSX.Element => {

    return <div style     = {{fontSize: monthlySummaryFontSize1}} 
	            className = {styles.monthlySummaryContainer}  >
             <h2 className = {styles.title} 
			     style     = {{fontSize: monthlySummaryFontSize1}}>
			   Données mensuelles
		     </h2>
             <WidgetFrame name               = "CA :"
                          labelTextPosition  = "right"
                          labelBlockPosition = "left"
                          classNameGrid      = {classNames(styles.grid_frame_monthly_sumary)} >
               <span className = {classNames(styles.number)} 
			         style     = {{fontSize: monthlySummaryFontSize2}}>
				 {(monthlyRevenue/100).toFixed(2)} €
			   </span>
             </WidgetFrame>
             <WidgetFrame name               = "Commandes :"
                          labelTextPosition  = "right"
                          labelBlockPosition = "left"
                          classNameGrid      = {classNames(styles.grid_frame_monthly_sumary)} >
               <span className = {classNames(styles.number)} 
			         style     = {{fontSize: monthlySummaryFontSize2}}>
				 {monthlyOrderCount}
			   </span>
             </WidgetFrame>
             <WidgetFrame name               = "Panier moyen :"
                          labelTextPosition  = "right"
                          labelBlockPosition = "left"
                          classNameGrid      = {classNames(styles.grid_frame_monthly_sumary)} >
               <span className = {classNames(styles.number)} 
			         style     = {{fontSize: monthlySummaryFontSize2}}>{(monthlyAverageOrderValue/100).toFixed(2)} €</span>
           </WidgetFrame>
         </div >
  }
  
  return (
    
      <div ref={monthlySummaryRef} className={classNames(styles.root)}>

        <div className={classNames(styles.overlay)}>
		  {showWaitingIcon && <AnimatedWaitingIcon />}
        </div>

        { monthlySummaryReady && renderMonthlySummary() }
		
      </div>

  );
};

export default MonthlySummary;
